export function StatCard({
  label,
  value,
  detail,
}: {
  label: string;
  value: string | number;
  detail?: string;
}) {
  return (
    <div className="rounded-lg border border-line bg-field p-5 shadow-soft">
      <p className="text-sm font-medium text-graphite/65">{label}</p>
      <p className="mt-3 text-3xl font-semibold text-ink">{value}</p>
      {detail ? <p className="mt-2 text-sm text-graphite/60">{detail}</p> : null}
    </div>
  );
}
